import { Breakpoints } from '@/settings/breakpoints';

export const RECOMMENDATIONS_BREAKPOINTS = {
  [Breakpoints.NONE]: {
    slidesPerView: 1.25,
    slidesPerGroup: 1,
    spaceBetween: 12,
  },
  [Breakpoints.XXS]: {
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    spaceBetween: 12,
  },
  [Breakpoints.XS]: {
    slidesPerView: 1.75,
    slidesPerGroup: 1,
    spaceBetween: 12,
  },
  [Breakpoints.SM]: {
    slidesPerView: 2.25,
    slidesPerGroup: 1,
    spaceBetween: 12,
  },
  [Breakpoints.MD]: {
    slidesPerView: 3.25,
    slidesPerGroup: 1,
    spaceBetween: 12,
  },
  [Breakpoints.LG]: {
    slidesPerView: 2.75,
    slidesPerGroup: 1,
    spaceBetween: 12,
  },
  [Breakpoints.XL]: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 12,
  },
};
